import './App.css';
import './styles/global.scss';

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import ScrollToTop from './components/ScrollToTop';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import PortfolioIntro from './components/PortfolioIntro';
import ProjectsCTA from './components/ProjectsCTA';
import FooterCTA from './components/FooterCTA';
import Services from './components/Services';
import Contact from './components/Contact';
import About from './components/About';

const HomePage = () => (
  <>
    <Hero />
    <Highlights />
    <ProjectsCTA />
    <FooterCTA />
  </>
);

const PortfolioPage = () => (
  <>
    <PortfolioIntro />
    <FooterCTA />
  </>
);

const ServicesPage = () => (
  <>
    <Services />
    <FooterCTA />
  </>
);

const ContactPage = () => (
  <>
    <Contact />
    <FooterCTA />
  </>
);

const AboutPage = () => (
  <>
    <About />
    <FooterCTA />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Nav />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
